/**
 * Valida se um número de CPF é verdadeiro com base no cálculo dos dígitos verificadores.
 */
export function validarCPF(cpfCliente) {
  if (!cpfCliente) return false;
  
  const cpfLimpo = cpfCliente.replace(/\D/g, "");

  if (cpfLimpo.length !== 11) return false;
  if (/^(\d)\1+$/.test(cpfLimpo)) return false;

  let soma = 0;
  let resto;

  for (let i = 1; i <= 9; i++) {
    soma += parseInt(cpfLimpo.substring(i - 1, i)) * (11 - i);
  }

  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpfLimpo.substring(9, 10))) return false;

  soma = 0;

  for (let i = 1; i <= 10; i++) {
    soma += parseInt(cpfLimpo.substring(i - 1, i)) * (12 - i);
  }

  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpfLimpo.substring(10, 11))) return false;

  return true;
}

/* FUNÇÕES DE FORMATAÇÃO E MÁSCARAS */

export const aplicarMascaraCPF = (valor) => {
  if (!valor) return "";
  return valor
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    .substring(0, 14);
};

export const aplicarMascaraCEP = (valor) => {
  if (!valor) return "";
  return valor
    .replace(/\D/g, "")                  // Remove caracteres não numéricos
    .replace(/^(\d{5})(\d)/, "$1-$2")     // Insere o hífen após os primeiros 5 dígitos
    .substring(0, 9);                    // Limita a 9 caracteres (ex: 12345-678)
};

export const aplicarMascaraTelefone = (valor) => {
  if (!valor) return "";
  return valor
    .replace(/\D/g, "")
    .replace(/(\d{2})(\d)/, "($1) $2")
    .replace(/(\d{5})(\d)/, "$1-$2")
    .substring(0, 15);
};

/**
 * Converte strings de data (ex: "AAAA/MM/DD", "AAAA-MM-DD" ou ISO String) para o formato "DD/MM/AAAA".
 */
export const formatarData = (dataStr) => {
  if (!dataStr) return "Não informada";
  
  const [dataApenas] = dataStr.split("T");
  const partes = dataApenas.split(/[-/]/);
  
  if (partes.length === 3 && partes[0].length === 4) {
    const [ano, mes, dia] = partes;
    return `${dia.padStart(2, "0")}/${mes.padStart(2, "0")}/${ano}`;
  }
  
  return new Date(dataStr).toLocaleDateString("pt-BR", { timeZone: "UTC" });
};

/**
 * Converte o nome de uma pessoa para caixa alta (UPPERCASE).
 */
export const formatarNomeUpper = (nome) => {
  if (!nome || typeof nome !== "string") return "";
  return nome.toUpperCase().trim();
};

/**
 * Converte o nome de uma pessoa para caixa baixa (LOWERCASE) trocando underline por espaço.
 */
export const formatarNomeLower = (nome) => {
  if (!nome || typeof nome !== "string") return "";
  return nome.toLowerCase().trim().replace(/_/g, " ");
};